import {
  type IoConfig,
  type NsHostTypeSlotId,
  type WithIoConfig,
  type WithNsHostTypeSlot,
} from '@blaze-runtime/engine-domain';

import { registerElementDefinition } from '../../services/element-definitions.service';

import { NavContainerComponent } from './nav-container.component';

// Extend the CanvasElementDefinitions type
declare module '@blaze-runtime/engine-domain' {
  interface CanvasElementDefinitions {
    navContainer: NavContainerDef;
  }
}

export const NAV_HOST_SLOT: NsHostTypeSlotId = 'nsHostType:Header';
export type NavContainerDef = WithNsHostTypeSlot & WithIoConfig;

registerElementDefinition({
  type: 'navContainer',
  componentType: NavContainerComponent,
  isListed: true,
  name: 'Navigation Header',
  width: { mode: 'full' },
  height: { mode: 'auto' },
  slots: {
    ids: [NAV_HOST_SLOT],
    [NAV_HOST_SLOT]: {
      children: [],
      hosting: {},
    },
  },
  ioConfig: getIoConfig(),
  tags: ['Nav Menu'],
  groups: ['navigation'],
  version: 1,
});

function getIoConfig(): IoConfig {
  return {
    inputs: [
      {
        name: 'visible',
        bindingDefs: [{ property: 'visible', label: 'Is Visible', dataType: 'Boolean' }],
      },
    ],
    outputs: [],
  };
}
